module.exports = __webpack_public_path__ + "img/icon_caso_de_sucesso_suporte_especializado.e4e702e5.svg";